import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import Welcome from "@/assets/welcome.svg";
import Global from "@/assets/icons/Global";
import { useTranslation } from "react-i18next";

interface WelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onFinishOnboarding: () => void;
  showDashboardButton?: boolean;
}

export function WelcomeModal({
  isOpen,
  onClose,
  onFinishOnboarding,
  showDashboardButton = false,
}: WelcomeModalProps) {
  const { t } = useTranslation("common");

  return (
    <Dialog onOpenChange={onClose} open={isOpen}>
      <DialogContent className="sm:max-w-[425px] w-[92%] p-0">
        <img className="relative w-full" src={Welcome} alt={"img"} />
        <DialogHeader className="px-6 relative mt-6">
          <span className="absolute -top-[62px] left-[20px]">{<Global />}</span>
          <DialogTitle>{t("welcome")}</DialogTitle>
          <DialogDescription>{t("welcomeDescription")}</DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4 px-4">
          <DialogFooter className="flex gap-4">
            {/* {showDashboardButton && (
              <Button
                className='bg-bg-transparent mr-2'
                type='button'
                variant='secondary'
                onClick={() => navigate('/dashboard')}
              >
                {t('go_to_dashboard')}
              </Button>
            )} */}
            <Button
              className="bg-bg-transparent mr-2"
              type="button"
              variant="secondary"
              onClick={onClose}
            >
              {t("skip")}
            </Button>
            <Button type="submit" onClick={onFinishOnboarding}>
              {t("finish_onboard")}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  );
}
